import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-aqua/15 bg-white/80 shadow-sm" data-id="element-348">
    <div className="flex items-center mb-4" data-id="element-349">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-aqua/10 flex items-center justify-center text-brand-darkGreen font-serif font-bold text-sm md:text-xl border border-brand-aqua/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-350">
        {initials}
      </div>
      <div data-id="element-351">
        <div className="flex text-brand-gold mb-1 text-[15px] md:text-lg" data-id="element-352">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-353" />)}
        </div>
        <div className="font-medium text-brand-darkGreen md:text-lg" data-id="element-354">
          {name}
        </div>
        <div className="text-xs md:text-sm text-brand-muted" data-id="element-355">{location}</div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] md:text-base font-serif leading-relaxed" data-id="element-356">
      "{text}"
    </p>
  </div>;
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'VG',
    name: 'Valeria G.',
    location: 'Terapeuta Gestáltica',
    text: 'Siempre sentí que lo mío era el consultorio y no las redes. Este kit me enseñó a mostrar mi trabajo de una forma súper respetuosa y profesional. En un mes llené los 4 espacios que tenía libres.'
  }, {
    initials: 'JP',
    name: 'Julián P.',
    location: 'Facilitador de Constelaciones',
    text: 'Las ideas de contenido son oro puro. Dejé de perder horas pensando qué subir. Ahora tengo un calendario claro y la gente me escribe diciendo "es exactamente lo que me pasa".'
  }, {
    initials: 'MR',
    name: 'Mariana R.',
    location: 'Terapeuta Floral',
    text: 'El módulo de identidad me voló la cabeza. Me di cuenta de que mi mensaje era súper genérico. Al aplicar la estructura de 4 piezas, mi propuesta quedó clarísima y empecé a atraer consultantes mucho más comprometidos.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-357">
      <div className="text-center mb-12" data-id="element-358">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-darkGreen pt-[0px]" data-id="element-359">
          ❤️ MÁS TERAPEUTAS QUE YA TRANSFORMARON SU VISIBILIDAD
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px] md:text-sm max-w-6xl mx-auto" data-id="element-360">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-361" />)}
      </div>
    </Section>;
};